export const LIMITS = {
  actor: 40,
  title: 120,
  content: 200_000,
  comment: 5_000,
  revisionSummary: 500,
  jsonBodyBytes: 256_000,
  attachmentName: 255,
  attachmentBytes: 10 * 1024 * 1024,
  attachmentsPerDocument: 50,
} as const

export const REVISION_SOURCES = ['human', 'ai', 'restore'] as const

export const SESSION_COOKIE = 'shc_docs_session'
export const SESSION_DURATION_MS = 24 * 60 * 60 * 1000
